import { InputState, Link } from '../inputField/types';
import React from 'react';
import InputField from '../inputField';

type InputAttributes = React.InputHTMLAttributes<HTMLInputElement>;

type Props = {
  label?: string;
  id: InputAttributes['id'];
  name?: InputAttributes['name'];
  subText?: string;
  placeholder?: InputAttributes['placeholder'];
  value?: InputAttributes['value'];
  helperText?: string;
  link?: Link;
  inputState?: InputState;
  disabled?: InputAttributes['disabled'];
  onBlur?: () => void;
  onChange?: (value: string) => void;
  onEnterPressed?: () => void;
  type?: InputAttributes['type'] | 'textarea' | 'hidden';
  className?: string;
  icon?: React.ReactNode;
};

const TextInput = ({
  id,
  name,
  placeholder,
  label,
  subText,
  helperText,
  link,
  disabled,
  inputState,
  value,
  onBlur,
  onChange,
  onEnterPressed,
  type = 'text',
  className = '',
  icon,
}: Props) => {
  return (
    <InputField
      id={id}
      name={name}
      placeholder={placeholder}
      label={label}
      subText={subText}
      helperText={helperText}
      link={link}
      disabled={disabled}
      inputState={inputState}
      value={value}
      onBlur={onBlur}
      onChange={onChange}
      onEnterPressed={onEnterPressed}
      type={type}
      className={className}
      icon={icon}
    />
  );
};

export default TextInput;
